import React, { FunctionComponent } from 'react';

import { DirectionWidgetItem, DirectionWidgetItemProps } from '../DirectionWidgetItem';
import { Wrapper } from './styles';
import { useMediaQuery } from '../../../../hooks';
import { DirectionWidgetSlider } from '../DirectionWidgetSlider';

interface Props {
  items: DirectionWidgetItemProps[];
  parentWidth?: number;
}

export const DirectionWidgetList: FunctionComponent<Props> = (props) => {
  const { items, parentWidth } = props;

  const isNotMobile = useMediaQuery('(min-width: 544px)');
  if (isNotMobile) {
    return (
      <Wrapper parentWidth={parentWidth}>
        {items.map((item) => (
          <DirectionWidgetItem key={item.destinationName} {...item} />
        ))}
      </Wrapper>
    );
  }
  return <DirectionWidgetSlider items={items} />;
};
